import type { FC } from "react"
import React, { useEffect, useMemo, useRef } from "react"
import { useTranslation } from "react-i18next"

import UButton from "../../../../ui-component/components/UButton/UButton"
import DialogBox from "../DialogBox/dialogBox"
import { formatDate } from "@/modules/Patient/PatientList/util/commonUtil"
import { safeCloseWindow } from "@/core/app/CloseTabContext"
import { useSearchParams } from "react-router-dom"
const CaseLockPopup: FC<any> = ({
  lockType,
  openLockPopup,
  setOpenLockPopup,
  lockInfo,
  clickControlOverride,
  allowControl = true,
  cancelNavigation,
}:any) => {
  const { t } = useTranslation("common")
  const [searchParams, setSearchParams] = useSearchParams()
  const removeDoRefinementQPRef = useRef(false)

  const lockContent = (type: number) => {
    switch (type) {
      //lock by uassist
      case 0:
        return (
          <>
            <p style={{ margin: "0", fontSize: "14px" }}>
              {t("treat.lockPopUp.uassist1")}
            </p>
            {/* <p
              style={{ margin: "0", fontSize: "14px" }}
            >{`They will let you know when it is "Ready to review".`}</p> */}
          </>
        )
      //order been place
      case 1:
        return (
          <p style={{ margin: "0", fontSize: "14px" }}>
            {t("treat.lockPopUp.orderPlace")}
          </p>
        )
      //order been place
      case 0.5:
        return (
          <p style={{ margin: "0", fontSize: "14px" }}>
            {t("treat.lockPopUp.orderPlace")}
          </p>
        )
      //edit by other user
      case 2:
        return (
          <>
            <p style={{ margin: "0", fontSize: "14px" }}>
              {t("treat.lockPopUp.otherUser")}
              <br />
              <span
                style={{
                  color: "#000",
                  fontSize: "12px",
                  letterSpacing: "0.4px",
                }}
              >{`${lockInfo.username}\u00A0\u00A0\u00A0${lockInfo.device_info}`}</span>

              <br />
              <br />
              {allowControl && t("treat.lockPopUp.controlContent")}
            </p>
          </>
        )
      case 3:
        return (
          <>
            <p style={{ margin: "0", fontSize: "14px" }}>
              {t("treat.lockPopUp.overContent1")}
              <br />
              <span
                style={{
                  color: "#000",
                  fontSize: "12px",
                  letterSpacing: "0.4px",
                }}
              >{`${lockInfo.username}\u00A0\u00A0\u00A0 ${formatDate(
                lockInfo.locked_date,
              )}`}</span>
              <br />
              <br />
              {/* {t("treat.lockPopUp.overContent2")} */}
            </p>
          </>
        )
      case 4:
        // Case is in production
        return (
          <p style={{ margin: "0", fontSize: "14px" }}>
            {t("treat.lockPopUp.orderProcessingDescription")}
          </p>
        )
      //order been place
      case -1:
        return (
          <p style={{ margin: "0", fontSize: "14px" }}>
            {t("treat.lockPopUp.byCRB")}
          </p>
        )
    }
  }

  useEffect(() => {
    if (openLockPopup) {
      cancelNavigation()
    }
  }, [openLockPopup])

  const title = useMemo(()=>{
    switch(lockType){
      case 3:
        return t("treat.lockPopUp.overTitle")
      case 4:
        return t("treat.lockPopUp.orderProcessingTitle")
      default:
        return t("treat.lockPopUp.title")
    }
  },[lockType, lockInfo])

  return (
    <DialogBox
      open={openLockPopup}
      title={title}
      content={lockContent(lockType)}
      actions={
        lockType > 1 && allowControl ? (
          <>
            <UButton
              onClickHandler={() => {
                setOpenLockPopup(false)
                if(!removeDoRefinementQPRef.current && searchParams.has("doRefinement")){
                  searchParams.set("doRefinement", "false")
                  setSearchParams(searchParams, { replace: true }) 
                }
                removeDoRefinementQPRef.current = true
                if (lockType === 3) {
                  cancelNavigation()
                }
              }}
              variant={"text"}
              btnText={t("button.cancel")}
            />
            {lockType === 3 && (
              <UButton
                onClickHandler={async () => {
                  // await dispatch(setSwitchViewEdit(false))
                  setOpenLockPopup(false)
                  safeCloseWindow()
                }}
                variant={"contained"}
                btnText={`discard & close`}
              />
            )}
            <UButton
              onClickHandler={()=>clickControlOverride()}
              variant={"contained"}
              btnText={
                lockType === 2 || lockType === 4
                  ? t("treat.lockPopUp.control")
                  : t("treat.lockPopUp.override")
              }
            />
          </>
        ) : (
          <>
            <UButton
              onClickHandler={() => {
                setOpenLockPopup(false)
                if (lockType === 0.5) {
                  safeCloseWindow()
                }
              }}
              variant={"contained"}
              btnText={
                lockType === 0.5 ? "CLOSE CASE" : t("treat.lockPopUp.okbtn")
              }
            />
          </>
        )
      }
    />
  )
}
export default CaseLockPopup
